import { render, staticRenderFns } from "./DashboardSlider.vue?vue&type=template&id=5de8e00a&"
import script from "./DashboardSlider.vue?vue&type=script&lang=js&"
export * from "./DashboardSlider.vue?vue&type=script&lang=js&"
import style0 from "./DashboardSlider.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports